//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    position: relative;
    display: grid;
    place-items: center;
    overflow: visible;
`;